// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Probeer het opnieuw met een volledige datum als deze: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Groep',
  chart_labelSeries: () => 'Reeks',
  chart_labelValue: () => 'Waarde',
  checkboxSet_requiredMessageDetail: () => 'Vereist',
  checkbox_requiredMessageDetail: () => 'Vereist',
  close: () => 'Sluiten',
  collection_noData: () => 'Er zijn geen gegevens om weer te geven.',
  collection_selectAllRows: () => 'Alle rijen selecteren',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Rij ' + p['ROW_NAME'] + ' selecteren',
  collection_sortDisabled: () => 'Niet sorteerbaar',
  collection_sortEnabled: () => 'Sorteerbaar',
  confirmation: () => 'Bevestiging',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' van de ' + p['totalCount'],
  dataVisualization_noData: () => 'Er zijn geen gegevens om weer te geven.',
  dataVisualization_stateSelected: () => 'Geselecteerd',
  dataVisualization_stateUnselected: () => 'Niet geselecteerd',
  error: () => 'Fout',
  expandableList_expandCollapseInstructionText: () =>
    'Gebruik de pijltoetsen om uit te vouwen en samen te vouwen',
  expandableList_groupCollapse: () => 'Samengevouwen',
  expandableList_groupExpand: () => 'Uitgevouwen',
  filePicker_addFiles: () => 'Bestanden toevoegen',
  filePicker_dropzonePrimaryText: () => 'Slepen en neerzetten',
  filePicker_dropzoneSecondaryText: () => 'Selecteer een bestand of zet er een hier neer.',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecteer bestanden of zet deze hier neer.',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'U kunt geen bestanden uploaden van dit type: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload één bestand per keer',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'U kunt geen bestanden uploaden van het type ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'onbekend',
  formControl_clear: () => 'Wissen',
  formControl_day: () => 'Dag',
  formControl_helpAvailable: () => 'Help beschikbaar',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'U hebt de limiet van ' +
    (({ one: '1 teken' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('nl').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('nl').format(p['CHARACTER_LIMIT']) + ' tekens') +
    ' bereikt.',
  formControl_loading: () => 'Bezig met laden',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximumlengte ' + p['MAX_LENGTH'] + ' is overschreden.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tekens over',
  formControl_month: () => 'Maand',
  formControl_readOnly: () => 'Alleen lezen',
  formControl_requiredMessageDetail: () => 'Voer een waarde in.',
  formControl_year: () => 'Jaar',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Einde',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Rij',
  gantt_labelStart: () => 'Begin',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Geen overeenkomende sectie gevonden.',
  indexer_keyboardInstructionText: () => 'Druk op Enter om waarde te selecteren.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tussen ' + p['FROM_SECTION'] + ' en ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dubbeltik en houd vast om gebarenmodus te activeren. Sleep vervolgens omhoog of omlaag om waarde aan te passen.',
  info: () => 'Informatie',
  inputDateMask_date_cleared: () => 'Datum gewist',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Leeg',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'jjjj',
  inputNumber_converterParseError: () => 'Voer een getal in.',
  inputNumber_decrease: () => 'Verkleinen',
  inputNumber_increase: () => 'Vergroten',
  inputPassword_hidden: () => 'Wachtwoord verborgen',
  inputPassword_hide: () => 'Wachtwoord verbergen',
  inputPassword_show: () => 'Wachtwoord tonen',
  list_suggestion: () => 'Suggestie',
  messageToast_allMessagesClosed: () => 'Alle toastmeldingen zijn gesloten.',
  message_close: () => 'Sluiten',
  message_confirmation: () => 'Gelukt',
  message_error: () => 'Fout',
  message_info: () => 'Informatie',
  message_navigationFromMessagesRegion: () =>
    'Berichtenregio wordt geopend. Druk op F6 om terug te navigeren naar het element dat hiervoor de focus had.',
  message_navigationToMessagesRegion: () =>
    'Berichtenregio bevat nieuwe berichten. Druk op F6 om naar de regio met de laatste berichten te gaan.',
  message_warning: () => 'Waarschuwing',
  noData_message: () => 'Geen items om weer te geven',
  overflowItemLabel: () => 'Meer tabbladen',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'In uitvoering',
  radio_helpForRadio: () => 'Help voor keuzerondje',
  radio_requiredMessageDetail: () => 'Selecteer een waarde.',
  selectMultiple_apply: () => 'Toepassen',
  selectMultiple_back: () => 'Terug',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    "Klik op 'Backspace' of 'Delete' om de geselecteerd waarde te verwijderen.",
  selectMultiple_selectedValues: () => 'Geselecteerde waarden',
  selectMultiple_showSelectedValues: () => 'Alleen geselecteerde waarden tonen',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' geselecteerde waarden',
  select_addToList: () => 'Toevoegen aan lijst',
  select_addToListAvailable: () => 'Toevoegen aan lijst beschikbaar',
  select_moreSearchOptions: () => 'Meer zoekopties',
  select_moreSearchOptionsAvailable: () => 'Meer zoekopties beschikbaar',
  select_noMatchesFound: () => 'Geen treffers gevonden.',
  select_oneMatchFound: () => 'Eén match gevonden.',
  select_requiredMessageDetail: () => 'Selecteer een waarde.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches gevonden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' of meer matches gevonden',
  selector_selected: () => 'Selectievakje ingeschakeld',
  selector_unselected: () => 'Selectievakje niet ingeschakeld',
  tabBarNavigationList_removeCueText: () => 'Verwijderbaar',
  timeComponent_tooltipZoomIn: () => 'Inzoomen',
  timeComponent_tooltipZoomOut: () => 'Uitzoomen',
  train_current: () => 'Huidig',
  train_message_type: () => 'Berichttype',
  train_not_visited: () => 'Niet bezocht',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Stap ' + p['currentStep'] + ' van ' + p['numberOfSteps'],
  train_visited: () => 'Bezocht',
  userAssistance_learnMore: () => 'Meer info',
  userAssistance_required: () => 'Vereist',
  viz_drillable: () => 'Inzoombaar',
  warn: () => 'Waarschuwing'
};
export default bundle;
